
<v-app id="inspire">
	<!-- Top Navigation Bar -->
	<user-nav-menu bg-color="#F6F6F6" :logo-file-name="tenant.settings.brandImages.headerLogos.app.dark"></user-nav-menu>

	<v-main>
		<v-container class fluid>
			<router-view />
			<!--slot / -->
		</v-container>
	</v-main>

	<request-form ref="RequestForm"></request-form>

	<v-footer app>
		<span>&copy; {{ new Date().getFullYear() }}</span>
	</v-footer>
</v-app>
